import type { MaintenanceLevel, MaintenanceScope } from "@/types/maintenance-window";
import { calcularFaseDaCarencia, segundosRestantesAte } from "./gracePeriodPhase";

export interface EstadoParaDecisaoDeTrava {
  isActive: boolean;
  scope: MaintenanceScope | null;
  level: MaintenanceLevel | null;
  /** ISO string ou null — o mesmo dado cru que o backend usa em
   * is_login_blocked. Correção 28/09/2026 (achado ALTO da revisão de
   * segurança): a versão anterior recebia um `phase` PRÉ-CALCULADO, que o
   * evento WS "active" grava como `null` no instante da ativação (toda
   * ativação tem carência ≥10s) — então o helper tratava "ainda não
   * calculei a fase" como "trava", mandando o não-admin pra /maintenance
   * DURANTE a carência que deveria liberar o login. Calculando a fase AQUI
   * a partir de `gracePeriodEndsAt`, o resultado não depende de quem
   * preencheu o contexto ter calculado `phase` certo. */
  gracePeriodEndsAt: string | null;
}

/**
 * Espelha, no front, a MESMA regra do backend (contrato item 1,
 * docs/superpowers/plans/2026-09-28-manutencao-no-login.md /
 * app.services.maintenance_window_service.is_login_blocked): manutenção
 * TRAVADA = ativa, escopo total/nuclear (escopo "partial" nunca trava — só
 * os módulos afetados travam, via middleware), nível != level_3 (nível 3 é
 * somente-leitura: ENTRAR pra ler é permitido) e fora das fases warn/save da
 * carência de sessão (Story 3.5 — quem já está logado tem esse tempo pra
 * salvar o trabalho antes de travar). A partir de readonly/logout, carência
 * vencida, ou sem carência configurada, trava.
 *
 * Usada por Login.tsx (aviso pré-submit, formulário continua habilitado) e
 * pelo guard de rotas autenticadas (App.tsx ProtectedRoute — usuário logado
 * sem `maintenance:activate` vai pra /maintenance).
 */
export function manutencaoEstaTravada(estado: EstadoParaDecisaoDeTrava): boolean {
  if (!estado.isActive) return false;
  if (estado.scope === "partial") return false;
  if (estado.level === "level_3") return false;

  const segundosRestantes = segundosRestantesAte(estado.gracePeriodEndsAt);
  if (segundosRestantes !== null && segundosRestantes > 0) {
    const fase = calcularFaseDaCarencia(segundosRestantes);
    if (fase === "warn" || fase === "save") return false;
  }

  return true;
}
